import { normaliseTamStatus } from "./status-rules.js";

const SEVERITY_RANK = new Map([
  ["ok", 0],
  ["notice", 1],
  ["warning", 2],
  ["error", 3],
]);

function mergeSeverity(current, next) {
  const currentRank = SEVERITY_RANK.get(current) ?? 0;
  const nextRank = SEVERITY_RANK.get(next) ?? 0;
  return nextRank > currentRank ? next : current;
}

function resolveTimestamp(value) {
  if (!value) {
    return null;
  }
  const parsed = Date.parse(value);
  if (Number.isFinite(parsed)) {
    return parsed;
  }
  return null;
}

export function assessStatusReliability({
  fetchedAt,
  statusError,
  tamStatus,
  autoCategory,
  staleThresholdMs,
} = {}) {
  const issues = [];
  let severity = "ok";
  const threshold = Number.isFinite(staleThresholdMs) && staleThresholdMs > 0 ? staleThresholdMs : 15 * 60 * 1000;
  const now = Date.now();
  const fetchedTimestamp = resolveTimestamp(fetchedAt);
  const statusAgeMs = fetchedTimestamp !== null ? Math.max(0, now - fetchedTimestamp) : null;

  if (fetchedTimestamp === null) {
    issues.push({ type: "missing", severity: "error" });
    severity = mergeSeverity(severity, "error");
  } else if (statusAgeMs >= threshold) {
    issues.push({
      type: "stale",
      severity: "warning",
      thresholdMs: threshold,
      fetchedAt: new Date(fetchedTimestamp).toISOString(),
      statusAgeMs,
    });
    severity = mergeSeverity(severity, "warning");
  }

  if (statusError) {
    issues.push({ type: "error", severity: "error", errorMessage: statusError });
    severity = mergeSeverity(severity, "error");
  }

  const tamNormalised = normaliseTamStatus(tamStatus);
  const autoNormalised = normaliseTamStatus(autoCategory);
  if (tamNormalised && autoNormalised && tamNormalised !== autoNormalised) {
    issues.push({
      type: "mismatch",
      severity: "warning",
      tamStatus: tamNormalised,
      autoStatus: autoNormalised,
      autoDisplay: autoCategory,
    });
    severity = mergeSeverity(severity, "warning");
  }

  return {
    isReliable: issues.length === 0,
    severity: issues.length === 0 ? "ok" : severity,
    statusAgeMs,
    fetchedAt: fetchedTimestamp !== null ? new Date(fetchedTimestamp).toISOString() : null,
    staleThresholdMs: threshold,
    issues,
  };
}
